import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TPostV1TransferParams,
  TPostV1TransferResponse,
  postV1Transfer,
  TGetGetAppLatestVersionParams,
  TGetGetAppLatestVersionResponse,
  getGetAppLatestVersion,
  TGetListArticleParams,
  TGetListArticleResponse,
  getListArticle,
  TGetListBannerParams,
  TGetListBannerResponse,
  getListBanner,
  TGetRegionCurrencyListParams,
  TGetRegionCurrencyListResponse,
  getRegionCurrencyList,
  TGetSafyInterfaceParams,
  TGetSafyInterfaceResponse,
  getSafyInterface,
  TPostGsipParams,
  TPostGsipResponse,
  postGsip,
  TGetPublicCommonLocalesParams,
  TGetPublicCommonLocalesResponse,
  getPublicCommonLocales,
  TPostV2TransferParams,
  TPostV2TransferResponse,
  postV2Transfer,
  TPostPublicGetAppConfigParams,
  TPostPublicGetAppConfigResponse,
  postPublicGetAppConfig,
  TGetPublicGetWebConfigParams,
  TGetPublicGetWebConfigResponse,
  getPublicGetWebConfig,
  TGetPublicCurrencyDetailParams,
  TGetPublicCurrencyDetailResponse,
  getPublicCurrencyDetail,
} from 'core/service/yapi/hk-web/Common/api'
// 公共接口
// 资金划账
export const usePostV1TransferMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1TransferResponse, TPostV1TransferParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Common', 'V1Transfer', 'Post'],
    mutationFn: (params?: TPostV1TransferParams) => postV1Transfer(params),
  })
}

// hotcoin优化---获取最新可更新APP版本，没有则不返回
export const useGetGetAppLatestVersionQuery = (
  params?: TGetGetAppLatestVersionParams,
  options?: TUseQueryOptions<TGetGetAppLatestVersionResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'GetAppLatestVersion', 'GET', ...Object.values(params || {})],
    queryFn: () => getGetAppLatestVersion(params),
  })
}

// hotcoin优化---获取公告列表
export const useGetListArticleQuery = (
  params?: TGetListArticleParams,
  options?: TUseQueryOptions<TGetListArticleResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'ListArticle', 'GET', ...Object.values(params || {})],
    queryFn: () => getListArticle(params),
  })
}

// hotcoin优化---获取轮播图、登录弹窗等
export const useGetListBannerQuery = (
  params?: TGetListBannerParams,
  options?: TUseQueryOptions<TGetListBannerResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'ListBanner', 'GET', ...Object.values(params || {})],
    queryFn: () => getListBanner(params),
  })
}

// 专区币种列表
export const useGetRegionCurrencyListQuery = (
  params?: TGetRegionCurrencyListParams,
  options?: TUseQueryOptions<TGetRegionCurrencyListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'RegionCurrencyList', 'GET', ...Object.values(params || {})],
    queryFn: () => getRegionCurrencyList(params),
  })
}

// 加密接口说明
export const useGetSafyInterfaceQuery = (
  params?: TGetSafyInterfaceParams,
  options?: TUseQueryOptions<TGetSafyInterfaceResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'SafyInterface', 'GET', ...Object.values(params || {})],
    queryFn: () => getSafyInterface(params),
  })
}

// 获取系统初始化参数(加密不签名)
export const usePostGsipMutation = (mutationOptions?: TUseMutationOptions<TPostGsipResponse, TPostGsipParams>) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Common', 'Gsip', 'Post'],
    mutationFn: (params?: TPostGsipParams) => postGsip(params),
  })
}

// 查询受限制的国家或地区列表
export const useGetPublicCommonLocalesQuery = (
  params?: TGetPublicCommonLocalesParams,
  options?: TUseQueryOptions<TGetPublicCommonLocalesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'PublicCommonLocales', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicCommonLocales(params),
  })
}

// 资金划账
export const usePostV2TransferMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2TransferResponse, TPostV2TransferParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Common', 'V2Transfer', 'Post'],
    mutationFn: (params?: TPostV2TransferParams) => postV2Transfer(params),
  })
}

// 获取APP配置信息
export const usePostPublicGetAppConfigMutation = (
  mutationOptions?: TUseMutationOptions<TPostPublicGetAppConfigResponse, TPostPublicGetAppConfigParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Common', 'PublicGetAppConfig', 'Post'],
    mutationFn: (params?: TPostPublicGetAppConfigParams) => postPublicGetAppConfig(params),
  })
}

// 获取WEB配置信息
export const useGetPublicGetWebConfigQuery = (
  params?: TGetPublicGetWebConfigParams,
  options?: TUseQueryOptions<TGetPublicGetWebConfigResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'PublicGetWebConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicGetWebConfig(params),
  })
}

// 根据币种名称查询币种详情
export const useGetPublicCurrencyDetailQuery = (
  params?: TGetPublicCurrencyDetailParams,
  options?: TUseQueryOptions<TGetPublicCurrencyDetailResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['Common', 'PublicCurrencyDetail', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicCurrencyDetail(params),
  })
}
